// Keep this file in alphabetical order.
module.exports = {
  breadcrumbs: true,
  claimCourse: true,
  courseReviews: true,
  courseOperators: false,
  courseOperatorsFreeMarketplace: false,
  courseOperatorsFreeMarketplaceSignupDetails: false,
  courseOperatorsVipPerks: false,
  courseOperatorsGolfCourseResources: false,
  courseSuggestion: false,
  featuredContests: true,
  dealsNav: true,
  dealsPage: true,
  deleteUser: true,
  disclaimerPage: true,
  exploreCountriesStates: true,
  extendedSupportForm: false,
  feedbackPage: true,
  forCourses: true,
  giftCardLink: true,
  golfTimePromotions: false,
  golfSpecials: true,
  hasNavMenu: true,
  hereToHelp: true,
  marketingCommunication: true,
  marketingOptInDefault: false,
  membership: true,
  moderator: true,
  nearMeNav: true,
  networkMembership: true,
  showNetworkSales: true,
  offers: true,
  partnerLogo: true,
  poweredByLogo: false,
  poweredByLogoScenery: false,
  priceAlerts: true,
  providerLogos: true,
  recommendedCourses: false,
  reviewAttachmentCta: true,
  rewardsBranding: true,
  rewardsAccumulation: true,
  rewardsReferral: true,
  sectionCourses: false,
  shareReservation: true,
  showDealsOnly: true,
  showForeplayReviewedOnly: false,
  showNearByAlertForm: true,
  showPrepaidRoundsFilter: true,
  showBarstoolBestFilter: false,
  showNetworkMembershipFilter: true,
  category: true,
  storeUrl: false,
  subScenery: false,
  supportReason: true,
  topDeals: true,
  barstoolVip: false,
  showTeeTimesBlog: true,
  showSuperBowlBlog: true,
};
